export default function(state = 'fr-FR') {
    return state;
}
